export const msalConfig = {
  auth: {
    clientId: 'f3ad2154-7e10-4730-a055-8852ced42d47',
    authority: "https://login.microsoftonline.com/common",
    // L'ORIGINE RÉELLE, jamais une URL en dur.
    //
    // Ce fichier se recopie sur Config.js pour travailler sur cet environnement. Avec une
    // URL figée, MSAL renvoie le code d'autorisation sur CETTE origine-là quelle que soit
    // celle de la page : depuis localhost:3000, l'iframe cachée atterrit sur le site QA et
    // la page parente ne peut plus lire le fragment (origines différentes). MSAL expire
    // sans jeton, `getAccessToken` avale l'échec, et les requêtes partent avec un
    // `Bearer undefined` — 401 partout, avec un message qui parle de droits alors que le
    // problème est l'authentification. Constaté le 29/08/2026.
    //
    // Les origines concernées sont toutes déclarées en SPA sur l'application f3ad2154-….
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};
export const loginRequest = {
  scopes: ["User.Read"],
};
export const HEEDIFY_PROVISIONING_BASE_URL = "https://func-provisioning-qa-ne-05.azurewebsites.net/api/V2";
// ⚠️ Le repli était `analytics.heedify.io` — la PRODUCTION — dans le fichier de configuration
// de la QA. Le portail de QA interrogeait donc le Data_Pipe de production : sur AcmeLab,
// « total-calls » rendait 0 côté prod et 4 côté QA, pour la même requête et le même tenant.
// Un tableau de bord vide, sans erreur, sans trace : le pire mode de panne.
export const ANALYTICS_API_BASE_URL = "https://func-analytics-qa-ne-01.azurewebsites.net/api";
export const GRAPH_BASE_URL = "https://graph.microsoft.com/v1.0";
export const TEXT_TO_SPEECH_URL = "https://func-tts-qa-ne-01.azurewebsites.net/api/text2Speech";
export const SIGNALR_URL = "https://func-signalr-qa-ne-01.azurewebsites.net/api";
